// src/pages/Users/ArbitrageJudo/components/ArbitrageRulePill.jsx

import React from "react";
import { FaCircle } from "react-icons/fa";

export default function ArbitrageRulePill({
  children,
  icon: Icon = FaCircle,
  compact = false,
}) {
  return (
    <div
      className={`flex items-start gap-3 rounded-2xl border border-slate-200 bg-white text-slate-700 shadow-sm dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300 ${
        compact ? "px-3 py-2.5" : "px-4 py-3"
      }`}
    >
      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-yellow-100 text-yellow-700 dark:bg-yellow-950/50 dark:text-yellow-300">
        <Icon className="text-[11px]" />
      </span>

      <p className="text-sm leading-6">{children}</p>
    </div>
  );
}